import { Component, EventEmitter, forwardRef, Inject, Input, Output } from '@angular/core';

import { CompanyService } from '../companies/company.service';
import { SessionService } from '../sessions/session.service';

@Component({
  selector   : 'wor-vehicle-form-default',
  template: require('./vehicle.form-default.component.html')
})
export class VehicleFormDefaultComponent {
  @Input() vehicle: any;
  @Input() company: any;
  @Input() customer: any;
  @Input() states: any[];
  @Input() body_types: any[];
  @Input() body_types_limited: any[];
  @Input() transmission_types: any[];
  @Input() fuel_types: any[];
  @Input() drive_types: any[];
  @Input() trackingCategoryOptions: any[];
  @Input() regoLabel: string;
  @Input() vinLabel: string;
  @Input() fleetCodeLabel: string;
  @Input() distanceLabel: string;
  @Input() plateDuplicate: boolean;
  @Input() vinDuplicate: boolean;

  @Output() onCheckPlate   = new EventEmitter<void>();
  @Output() onDelete       = new EventEmitter<void>();
  @Output() onArchive      = new EventEmitter<void>();
  @Output() onSearchRegistration = new EventEmitter<void>();
  @Output() onSetTrackingCategory = new EventEmitter<void>();

  constructor(
    @Inject(forwardRef(() => CompanyService)) public companyService: CompanyService,
    @Inject(forwardRef(() => SessionService)) public sessionService: SessionService
  ) {}

  isPlateNumberSearchAvailable(): boolean {
    return !this.companyService.isDealer()
      && (this.companyService.hasIntegration('dvla-lookup')
        || this.companyService.hasIntegration('vehicle-registrations')
        || this.companyService.hasIntegration('carfax')
      );
  }

  canUnarchiveVehicle(): boolean {
    return this.vehicle.id
      && this.vehicle.archived
      && !this.customer.archived;
  }
}
